import React, { useState, useEffect } from "react";
import { Box, Paper, Tab, Tabs } from "@mui/material";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import { theme } from "../../Theme";
import PromoSimulatorDashboard from "./PromoSimulatorDashboard";
import PerformanceHistory from "./PerformanceHistory";
import {
  PROMO_ALL_BRANDS_ID,
  PROMO_ALL_CLASSES_ID,
  PROMO_DEFAULT_MANUFACTURER,
  PROMO_HISTORICAL_DEFAULT_YEAR,
} from "./services/promoSimulatorService";

const PI_SUB_TABS = [
  { label: "Performance History", icon: <HistoryOutlinedIcon fontSize="small" /> },
  { label: "Dashboard", icon: <DashboardOutlinedIcon fontSize="small" /> },
];

export default function PerformanceIntelligence({ onSwitchTab }) {
  const [filters, setFilters] = useState(() => ({
    manufacturer: PROMO_DEFAULT_MANUFACTURER,
    brand: PROMO_ALL_BRANDS_ID,
    class: PROMO_ALL_CLASSES_ID,
    startWeek: 1,
    endWeek: 52,
    year: PROMO_HISTORICAL_DEFAULT_YEAR,
  }));
  const [subTab, setSubTab] = useState(0);
  const [dashboardMounted, setDashboardMounted] = useState(false);

  useEffect(() => {
    if (subTab !== 1) return;
    setDashboardMounted(true);
  }, [subTab]);

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
        <Paper
          elevation={0}
          sx={{
            width: "100%",
            maxWidth: 1000,
            borderRadius: 2,
            border: "1px solid #F2F4F7",
            overflow: "hidden",
          }}
        >
          <Tabs
            value={subTab}
            onChange={(_, v) => setSubTab(v)}
            variant="fullWidth"
            aria-label="Performance Intelligence view"
            TabIndicatorProps={{
              children: (
                <span
                  style={{
                    display: "block",
                    width: "100%",
                    maxWidth: 200,
                    margin: "0 auto",
                    height: 2,
                    borderRadius: "3px 3px 0 0",
                    backgroundColor: theme.palette.primary.main,
                  }}
                />
              ),
            }}
            sx={{
              minHeight: 48,
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 500,
                fontSize: 13,
                minHeight: 48,
                minWidth: 0,
                px: { xs: 1.5, sm: 2 },
                gap: 0.5,
              },
            "& .Mui-selected": {
              fontWeight: 700,
              color: `${theme.palette.primary.main} !important`,
            },
            "& .MuiTabs-indicator": {
              display: "flex",
              justifyContent: "center",
              backgroundColor: "transparent",
              height: 3,
            },
          }}
        >
          {PI_SUB_TABS.map(({ label, icon }) => (
            <Tab key={label} label={label} icon={icon} iconPosition="start" />
          ))}
          </Tabs>
        </Paper>
      </Box>

      <Box>
        {subTab === 0 && (
          <PerformanceHistory filters={filters} setFilters={setFilters} onSwitchTab={onSwitchTab} />
        )}
        {dashboardMounted && (
          <Box
            sx={{ display: subTab === 1 ? "block" : "none" }}
            aria-hidden={subTab !== 1}
          >
            <PromoSimulatorDashboard
              key={`${filters.brand}|${filters.class}|${filters.manufacturer}`}
              onSwitchTab={onSwitchTab}
              filters={filters}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}

